export default "__VITE_ASSET__BCpOBVWr__"